<!-- Floating Chat Panel – always in DOM, toggled via CSS -->
<div [ngClass]="chatService.floatingChatOpen
      ? 'opacity-100 scale-100 pointer-events-auto'
      : 'opacity-0 scale-95 pointer-events-none'"
     [style.width.px]="chatService.panelWidth"
     class="fixed z-[9998] bg-white shadow-[0_8px_40px_rgba(0,0,0,0.15),0_0_0_1px_rgba(0,0,0,0.05)]
            flex overflow-hidden flex-row top-0 right-0 h-full border-l border-gray-200 origin-right
            transition-[opacity,transform] duration-200 ease-in-out">

  <button (click)="collapseFromHandle()"
         (mousedown)="startResizeWidth($event)"
         aria-label="chatBIC einklappen oder Breite ändern"
         class="relative w-4 h-full shrink-0 cursor-ew-resize group/handle hover:bg-gray-50 transition-colors"
         title="Ziehen zum Ändern der Breite, klicken zum Einklappen"
         type="button">
    <span class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                w-1.5 h-20 rounded-full bg-gray-400 group-hover/handle:bg-gray-500 transition-colors"></span>
  </button>

  <div class="flex flex-col flex-1 min-w-0 min-h-0 h-full">
    <!-- Header -->
    <div class="flex items-center justify-between px-4 border-b border-gray-200 shrink-0 h-[72px]">
      <div class="flex items-center gap-2 min-w-0">
        <fa-icon [icon]="faChatbicAi" class="text-blue text-lg shrink-0"></fa-icon>
        <span class="font-medium text-lg text-gray truncate">chatBIC</span>
      </div>
      <div class="flex items-center gap-1 shrink-0">
        <bic-button (click)="openNewChat()" buttonType="icon" title="Neuer Chat">
          <fa-icon [icon]="faPlus" class="text-svg-16"></fa-icon>
        </bic-button>
        <bic-button (click)="navigateToFullChat()" buttonType="icon" title="In chatBIC öffnen">
          <fa-icon [icon]="faChatbicAi" class="text-svg-16"></fa-icon>
        </bic-button>
        <bic-button (click)="togglePanel()" buttonType="icon" title="Schließen">
          <fa-icon [icon]="faXmark" class="text-svg-16"></fa-icon>
        </bic-button>
      </div>
    </div>

    <!-- Kontext-Chip im Edit-Chat (#2789): welcher myCheck und welches Element gerade bearbeitet
         wird. Eigene shrink-0-Zeile, damit er beim Scrollen des Verlaufs stehen bleibt. -->
    @if (chatService.activeSurface === 'edit' && proposalReview.contextText(); as text) {
      <div class="px-4 pt-3 shrink-0" data-chatbic-context-chip="true">
        <!-- Figma „Kontext-Chip“: gray-100, Radius 6, Padding 4/8, Abstand 6, Inter 12/1.5 – „Kontext“
             medium gray-500, der Name regular gray-900. -->
        <div [title]="text" class="flex flex-row items-center gap-1.5 rounded-md bg-gray-100 px-2 py-1 text-xs leading-normal">
          <span class="shrink-0 font-medium text-gray-500">Kontext</span>
          <span class="min-w-0 truncate font-normal text-gray-900" data-chatbic-context-text="true">{{ text }}</span>
        </div>
      </div>
    }

    <!-- Content -->
    <div class="flex-1 overflow-y-auto px-4 py-3">
      <app-chatBIC-view class="w-full h-auto" [surface]="chatService.activeSurface"></app-chatBIC-view>
    </div>
    <div class="px-4 pb-4 pt-2 shrink-0">
      <app-message-view class="w-full" [surface]="chatService.activeSurface"></app-message-view>
    </div>
  </div>
</div>

<!-- Docked chatBIC tab (right edge, only visible while the panel is closed).
     Sitzt zusammen mit dem bugBIC-Feedback-Tab symmetrisch um die Bildschirmmitte:
     chatBIC bei h/2 + gap/2, Feedback bei h/2 - gap/2 mit gap = 180px. Wird der Gap
     geaendert, muss der [offset] am <bug-bic-badge> in app.component.html mitziehen. -->
@if (!chatService.floatingChatOpen) {
  <button (click)="openPanel()"
          class="fixed right-0 top-[calc(50%_+_90px)] -translate-y-1/2 z-[9998] group
                 flex items-center h-[38px] px-3
                 bg-green text-white rounded-l-lg
                 shadow-[0_4px_16px_rgba(0,0,0,0.2)]
                 cursor-pointer overflow-hidden
                 transition-all duration-200 ease-in-out
                 hover:shadow-[0_6px_24px_rgba(0,0,0,0.3)]"
          type="button">
    <fa-icon [icon]="faChatbicAi" class="text-base shrink-0"></fa-icon>
    <span class="max-w-0 opacity-0 group-hover:max-w-[80px] group-hover:opacity-100 group-hover:ml-2
                 overflow-hidden whitespace-nowrap text-sm font-medium
                 transition-all duration-200 ease-in-out">chatBIC</span>
  </button>
}
